export interface IScreenshotErrors {
  emailError: string;
  statusError: string;
}

export const validateScreenshots = (
  email: File | null,
  status: File | null,
  requiredMessage: string
): IScreenshotErrors => ({
  emailError: email ? '' : requiredMessage,
  statusError: status ? '' : requiredMessage,
});

export const hasValidationErrors = ({
  emailError,
  statusError,
}: IScreenshotErrors): boolean => !!(emailError || statusError);
